import { NorrisQuest } from "./norrisQuest/NorrisQuest";

/** v3 — NorrisQuest: six Wikipedia links from the day's page to Chuck Norris. */
export function ValDailyV3() {
  return <NorrisQuest />;
}
